import type { ComputedRef } from "vue";
import { useFeatureFlag } from "@/features/experience-shared/composables/useFeatureFlag";
import { useIsCurrentExperienceOpinoia } from "@/features/experience-shared/composables/useIsCurrentExperienceOpinoia";

/**
 * Determines whether the voucher info field should be visible.
 *
 * When the `show_voucher_info_in_opinoia` feature flag is enabled, the field is always visible.
 * When it's disabled, the field is hidden for OPINOIA (INTERNAL) experiences,
 * preserving the legacy behaviour.
 */
export function useIsVoucherInfoVisible(): ComputedRef<boolean> {
  const isFlagEnabled = useFeatureFlag("show_voucher_info_in_opinoia");
  const isOpinoia = useIsCurrentExperienceOpinoia();

  return computed(() => isFlagEnabled || !isOpinoia.value);
}
